import React, {Component} from 'react';
import {cameraInitialPosition} from './settings';
import {ShipContext, ShipContextProvider} from './context/ShipContext';
import SceneManager from './three-js/SceneManager';
import ApplicationArea from './ApplicationArea';

class ThreeDShip extends Component {
    constructor(props) {
        super(props);

        this.props.setShipType(this.props.ship);

        this.requestAnimationFrameId = '';

        this.state = {
            shipHasLoaded: false,
        };

        this.shipModelContainerRef = React.createRef();
        this.hotspotsRefs = [];

        this.initScene = this.initScene.bind(this);
        this.renderLoop = this.renderLoop.bind(this);
        this.getTwoDCoordinatesFromThreeD = this.getTwoDCoordinatesFromThreeD.bind(this);
        this.moveCameraToPosition = this.moveCameraToPosition.bind(this);
        this.moveCameraToInitialPosition = this.moveCameraToInitialPosition.bind(this);
        this.handleWindowResizeEvent = this.handleWindowResizeEvent.bind(this);
        this.addHotspotRef = this.addHotspotRef.bind(this);
        this.positionHotspots = this.positionHotspots.bind(this);
    }

    componentDidMount() {
        this.sceneManager = new SceneManager(
            this.shipModelContainerRef.current,
            this.props.shipAssets.modelUrl,
            this.initScene
        );
    }

    componentWillUnmount() {
        this.unbindEventListeners();
    }

    initScene() {
        this.bindEventListeners();
        this.renderLoop();
        this.setState({shipHasLoaded: true});
        setTimeout(() => this.sceneManager.changeCameraPosition(cameraInitialPosition), 1000); // delay camera position change
    }


    bindEventListeners() {
        window.addEventListener('resize', this.handleWindowResizeEvent, false);
    }

    unbindEventListeners() {
        window.cancelAnimationFrame(this.requestAnimationFrameId);
        window.removeEventListener('resize', this.handleWindowResizeEvent, false);
    }

    handleWindowResizeEvent() {
        this.sceneManager.onWindowResize();
    }

    renderLoop() {
        this.requestAnimationFrameId = window.requestAnimationFrame(this.renderLoop);
        this.sceneManager.update();
        this.positionHotspots();
    }

    getTwoDCoordinatesFromThreeD(threeDCoordinates) {
        return this.sceneManager.getTwoDCoordinatesFromThreeD(threeDCoordinates);
    }

    moveCameraToPosition(coordinates) {
        this.sceneManager.changeCameraPosition(coordinates);
    }

    moveCameraToInitialPosition() {
        this.sceneManager.changeCameraPosition(cameraInitialPosition);
    }

    addHotspotRef(hotspotRef) {
        this.hotspotsRefs.push(hotspotRef);
    }

    positionHotspots() {
        const hotspotsRefs = this.hotspotsRefs,
            max = hotspotsRefs.length;

        for (let i = 0; i < max; i++) {
            hotspotsRefs[i].positionHotspot();
        }
    }

    render() {
        const shipModelAreas = this.props.applicationAreas.map((area) =>
            <ApplicationArea
                threeDShip={true}
                key={area.name}
                area={area}
                engineRoomImgUrl={this.props.shipAssets.engineRoomUrl}
                getTwoDCoordinatesFromThreeD={this.getTwoDCoordinatesFromThreeD}
                moveCameraToPosition={this.moveCameraToPosition}
                moveCameraToInitialPosition={this.moveCameraToInitialPosition}
                addHotspotRef={this.addHotspotRef}
                shipHasLoaded={this.state.shipHasLoaded}
            />
        );

        let styles = {};
        styles.opacity = this.props.activeShip === this.props.ship ? '1' : '0';
        styles.pointerEvents = this.props.activeShip === this.props.ship ? 'auto' : 'none';


        return (
            <div className="ships-viewer__container ships-viewer__container--3D"
                 style={styles}
                 ref={this.shipModelContainerRef}
            >
                {!this.state.shipHasLoaded &&
                <div className="loader">
                    <p className="visually-hidden-accessible">Loading in progress.</p>
                    <div className="loader__icon"/>
                </div>
                }
                {shipModelAreas}
            </div>
        )
    }
}

function ThreeDShipWithContext(props) {
    return (
        <ShipContextProvider>
            <ShipContext.Consumer>
                {(shipContext) => (
                    <ThreeDShip
                        setShipType={shipContext.setShipType}
                        {...props}
                    />
                )}
            </ShipContext.Consumer>
        </ShipContextProvider>
    )
}

export default ThreeDShipWithContext;